import { render, staticRenderFns } from "./WhatsappConnect.vue?vue&type=template&id=1a788838&"
import script from "./WhatsappConnect.vue?vue&type=script&lang=js&"
export * from "./WhatsappConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports